import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { LandingComponent } from './landing.component';
import { LANDING_ROUTES } from './landing.routes';

@NgModule({
  declarations: [LandingComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(LANDING_ROUTES),
  ],
  exports: [LandingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LandingModule { }
